import React, { Component } from "react";
import { Link, Route, withRouter } from "react-router-dom";
import moment from "moment-timezone";
import Admincss from "../../public/css/admin/css/admin.css";
import Httpconfig from "../helpers/HttpconfigAdmin";
import { ToastContainer } from "react-toastify";
import Constant from "../../constants";
import toast from "../../helpers/toast";
import {
  getAdminRole,
  isRestrictedRole,
  isPathAllowedForRole,
  isReadOnlyPathForRole,
  landingForRole,
  loginPathForRole,
  roleLabel,
  READ_ONLY_BODY_CLASS,
} from "../../helpers/adminRoles";

//  How often the panel re-checks that its session is still good. A user
//  deactivated while signed in is holding a session that is already dead on
//  the server, so the panel has to notice on its own rather than wait for the
//  user to navigate.
const SESSION_CHECK_MS = 60 * 1000;

class Header extends Component {
  constructor(props) {
    super(props);
    this.role = getAdminRole();
    //  Resolved before logout clears the session, so we always know which
    //  login page to send this user back to.
    this.loginPath = loginPathForRole(this.role);
    this.state = {
      validated: false,
    };
  }

  today = moment();

  //  Header renders on every admin screen, so this is the single place that
  //  keeps a restricted role inside the pages it is allowed to open. The
  //  server answers the data behind those pages with 403; this is what the
  //  user actually sees.
  enforceRolePermissions = () => {
    if (!isRestrictedRole(this.role)) return true;
    if (isPathAllowedForRole(this.role, window.location.pathname)) return true;
    toast.error("Access denied. You do not have permission to open that page.");
    setTimeout(() => {
      window.location.href = landingForRole(this.role);
    }, 1500);
    return false;
  };

  //  Operations may look at every screen outside Order Medicine but change
  //  nothing on it. Rather than have twenty list screens each ask whether to
  //  draw their edit and delete buttons, the answer is hung on <body> once and
  //  admin.css hides them - which also covers screens added later.
  applyReadOnlyChrome = () => {
    const readOnly = isReadOnlyPathForRole(this.role, window.location.pathname);
    const classes = document.body.classList;
    if (readOnly) {
      classes.add(READ_ONLY_BODY_CLASS);
    } else {
      classes.remove(READ_ONLY_BODY_CLASS);
    }
  };

  //  Clears the session and returns the user to their own login page
  endSession = () => {
    localStorage.removeItem("AdminUserObj");
    localStorage.removeItem("AdminToken");
    localStorage.setItem("validated", false);
    window.location.href = this.loginPath;
  };

  //  Session is over: say why once, then drop it. Guarded because the poll can
  //  come round again inside the delay, and the user should not get the same
  //  message twice.
  expireSession = (message) => {
    if (this.sessionEnding) return;
    this.sessionEnding = true;
    this.stopSessionWatch();
    toast.error(message || "Your session has ended. Please log in again.");
    setTimeout(() => this.endSession(), 1500);
  };

  startSessionWatch = () => {
    if (this.sessionWatch) return;
    this.sessionWatch = setInterval(this.validateToken, SESSION_CHECK_MS);
  };

  stopSessionWatch = () => {
    if (!this.sessionWatch) return;
    clearInterval(this.sessionWatch);
    this.sessionWatch = null;
  };
  //  For opennav
  openNav = () => {
    if (document.getElementById("mySidenav")) {
      document.getElementById("mySidenav").style.width = "250px";
    }
  };

  //  For logout
  logouts = (e) => {
    var retrievedObject = localStorage.getItem("AdminUserObj");
    if (retrievedObject == null) {
      window.location.href = this.loginPath;
      return;
    }
    let userData = JSON.parse(retrievedObject);

    let userID = userData.userID;
    Httpconfig.httptokenget(Constant.siteurl + "api/Users/logout/" + userID)
      .then((response) => {
        if (response.data.status == "200" && response.data.error === false) {
          toast.success(response.data.message);
          setTimeout(() => this.endSession(), 1000);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  //  Get the value for first render
  componentDidMount = () => {
    var retrievedObject = localStorage.getItem("AdminUserObj");
    if (retrievedObject == null) {
      window.location.href = this.loginPath;
      return;
    }
    if (!this.enforceRolePermissions()) return;
    this.applyReadOnlyChrome();
    this.validateToken();
    this.startSessionWatch();
  };

  //  withRouter re-renders the header on every navigation, so the checks run
  //  again when the user moves between screens rather than only on a full page
  //  load.
  componentDidUpdate = (prevProps) => {
    const previous = prevProps.location ? prevProps.location.pathname : null;
    const current = this.props.location ? this.props.location.pathname : null;
    if (previous === current) return;
    if (!this.enforceRolePermissions()) return;
    this.applyReadOnlyChrome();
    this.validateToken();
  };

  componentWillUnmount = () => {
    document.body.classList.remove(READ_ONLY_BODY_CLASS);
    this.stopSessionWatch();
  };
  //  For logout
  logout = () => {
    var dropdown = document.getElementsByClassName("dropdown-btn");
    var i;

    for (i = 0; i < dropdown.length; i++) {
      dropdown[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var dropdownContent = this.nextElementSibling;
        if (dropdownContent.style.display === "block") {
          dropdownContent.style.display = "none";
        } else {
          dropdownContent.style.display = "block";
        }
      });
    }
  };

  //  For validating the token
  validateToken = () => {
    if (this.sessionEnding) return;

    var retrievedObject = localStorage.getItem("AdminUserObj");

    if (retrievedObject == null) {
      window.location.href = this.loginPath;
      return;
    }

    let userData = JSON.parse(retrievedObject);
    let userId = userData.userID;
    if (retrievedObject != "") {
      let token = localStorage.getItem("AdminToken");
      if (token != "") {
        Httpconfig.httptokenpost(Constant.siteurl + "api/Users/checkToken", {
          userid: userId,
          token: token,
        })
          .then((response) => {
            //  error true covers both a token the server no longer holds and a
            //  user whose access has been switched off - either way the
            //  session is gone and the server sends the reason to show.
            if (response.data.status == "200" && response.data.error === true) {
              this.expireSession(response.data.message);
            }
          })
          .catch((error) => {
            //  The session check itself being refused means the session is no
            //  longer accepted; anything else is a transient network problem
            //  and the next poll can try again.
            if (error.response && error.response.status === 401) {
              this.expireSession(
                error.response.data && error.response.data.message
              );
              return;
            }
            toast.error(error);
          });
      } else {
        this.expireSession("Your Session has timed out.Please Relogin");
      }
    } else {
      this.expireSession("Your Session has timed out.Please Relogin");
    }
  };

  render() {
    const homePath = landingForRole(this.role);
    return (
      <nav className="navbar navbar-default navbar-fixed-top nav-head">
        <div className="container-fluid">
          <div className="navbar-header">
            <a href={homePath} class="scrollto">
              <img
                src={
                  window.location.origin + "/images/patient/img/main-logo.png"
                }
                alt=""
                class="img-fluid admin-logo"
              />
            </a>
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>

            <a className="navbar-brand" href="#">
              <i className="fa fa-bars admin_menu" onClick={this.openNav}></i>
            </a>
          </div>
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a className="dropdown-btn side_txt" onClick={this.logout}>
                <img
                  src="/img/profile.png"
                  className="user-image"
                  alt="User Image"
                />
                {roleLabel(this.role)} <span className="caret"></span>
              </a>
              <div className="dropdown-container drp_content">
                <a href="#" onClick={this.logouts}>
                  Logout
                </a>
              </div>
            </li>
          </ul>
        </div>
        <ToastContainer />
      </nav>
    );
  }
}

export default withRouter(Header);
